__webpack_require__.p = "/video-providers-fix/referrals/";